export const state = {
  finalCost: null,
  name: '',
  secondName: '',
  middleName: '',
  address: '',
  phone: '',
  comment: '',
  dialog: false
}

export const getters = {

}

export const mutations = {
  finalCostUpdate (state) {
    state.finalCost = this.state.Window1.costStep1Window1 + this.state.Window2.costStep1Window2 + this.state.Window3.costStep1Window3 + this.state.Window4.costStep1Window4 + this.state.Window5.costStep1Window5 + this.state.Window6.costStep1Window6 + this.state.Tulles.costTulle1 + this.state.Tulles.costTulle2 + this.state.Tulles.costTulle3 + this.state.Tulles.costTulle4 + this.state.Tulles.costTulle5 + this.state.Tulles.costTulle6 + this.state.Karniz.costKarniz1 + this.state.Karniz.costKarniz2 + this.state.Karniz.costKarniz3 + this.state.Karniz.costKarniz4 + this.state.Karniz.costKarniz5 + this.state.Karniz.costKarniz6 + this.state.AddOptions.costAdd1 + this.state.AddOptions.costAdd2 + this.state.AddOptions.costAdd3 + this.state.AddOptions.costAdd4 + this.state.AddOptions.costAdd5 + this.state.AddOptions.costAdd6
  },
  updateName (state, name) {
    state.name = name
  },
  updateSecondName (state, secondName) {
    state.secondName = secondName
  },
  updatePhone (state, phone) {
    state.phone = phone
  },
  updateAddress (state, address) {
    state.address = address
  },
  updateComment (state, comment) {
    state.comment = comment
  },
  updateDialog (state, dialog) {
    state.dialog = !dialog
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
